import { render } from "./agreement.vue?vue&type=template&id=1a5ed502&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"

import "./agreement.vue?vue&type=style&index=0&id=1a5ed502&lang=scss&scoped=true"
import "./agreement.vue?vue&type=style&index=1&id=1a5ed502&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5ed502"]])

export default __exports__